@if (cardDetails) {
  <app-block-card
    [cardDetails]="cardDetails"
    [cardType]="cardType"
    title="Block employee card">
    <ng-container blockCardHeading>
      @if (cardDetails.holder; as holder) {
        <div class="h4">Are you sure you want to block {{ holder.first_name }} {{ holder.last_name }}'s card?</div>
      }
    </ng-container>
  </app-block-card>
}
